// Common
import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.less', '../../styles.less'],
  standalone: false,
})
export class AdminLayoutComponent {}
